import { reportAdvancePaymentsTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_REPORT_ADVANCE_PAYMENTS_FILTERS,
  RESTORE_INITIAL
} = reportAdvancePaymentsTypes;

const initialState = {
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportAdvancePaymentsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_REPORT_ADVANCE_PAYMENTS_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return initialState;

    default:
      return state;
  }
};
